<template>

  <div
    v-if="customFieldGroups">

    <div
      class="card mb-3"
      v-for="(group, index) in customFieldGroups"
      :key="index">
      <div class="card-header">
        {{ group.name }}
      </div>
      <div class="card-body">

        <div
          class="form-group"
          v-for="(field, index) in group.custom_fields"
          :key="index">
          <label class="control-label"><strong>{{ field.label }}</strong></label>
          <value-custom-field
            v-if="fieldsValue && fieldsValue[field.key]"
            :type="field.type"
            :options="field.options"
            :value="fieldsValue[field.key]">
            </value-custom-field>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import ValueCustomField from './ValueCustomField'

export default {
  name: 'CustomView',
  components: {
    ValueCustomField
  },
  props: {
    'fieldsValue': {
      type: Object,
      default: () => { return {} }
    },
    'modelType': {
      type: String,
      default: null
    }
  },
  data () {
    return {
      customFieldGroups: false
    }
  },
  watch: {
  },
  created () {
    this.loadCustomFields()
  },
  methods: {
    loadCustomFields () {
      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/custom-field-groups?sort=position&model_type=' + this.modelType)
      .then((response) => {
        this.customFieldGroups = response.data
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/CustomView.vue